import React from 'react'

function DataNotFound() {
  return (
    <div style={{width:"100%" ,margin:"50px", textAlign:"center" ,height:"50vh"}}>
    <h1 style={{fontWeight:'bold'}} >Data Not Found!😔</h1>
    <img style={{height:"100%",width:"70%", borderRadius:"10px",boxShadow:"rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset"}} src="https://imgs.search.brave.com/PGQ4S2_L20H7itD54TyFROeFJPvOmwqYVRrPzm-5tkM/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9zdG9y/aWVzLmZyZWVwaWts/YWJzLmNvbS9zdG9y/YWdlLzQyMzQvTm8t/RGF0YS1icm8tMDEu/c3Zn.svg" alt="not found" />
    
  </div>
  )
}

export default DataNotFound